import { forwardRef } from "react";
import { Input } from "@/components/ui/input";

/**
 * IBAN input — otomatik TR öneki, sadece rakam, 24 hane sonrasında girişi durdurur.
 * Görsel format: TR__ ____ ____ ____ ____ ____ __
 * value: normalize edilmiş string (örn: TR12 3456 ...) — dış dünyaya boşluklu döner.
 */
const formatIban = (raw) => {
  // TR prefix + rakamlar
  const digits = String(raw || "").toUpperCase().replace(/[^0-9TR]/g, "").replace(/^TR/, "").replace(/[^0-9]/g, "");
  const limited = digits.slice(0, 24);
  const grouped = limited.match(/.{1,4}/g)?.join(" ") || "";
  return limited ? `TR${grouped ? " " + grouped : ""}` : "TR";
};

const IbanInput = forwardRef(({ value, onChange, ...props }, ref) => {
  const display = formatIban(value);

  const handleChange = (e) => {
    const formatted = formatIban(e.target.value);
    onChange?.({ target: { value: formatted } });
  };

  return (
    <Input
      ref={ref}
      type="text"
      value={display}
      onChange={handleChange}
      maxLength={32} // TR + 24 digits + 6 spaces = 32
      placeholder="TR__ ____ ____ ____ ____ ____ __"
      {...props}
    />
  );
});
IbanInput.displayName = "IbanInput";
export default IbanInput;
